/**
 * MasonryList 컴포넌트
 * @description 카드를 여러 열로 쌓는 목록. 시안에 대응물이 없는 우리 구조물이라 DS 가
 *   아니라 여기 산다. **정책은 갖지 않는다.** 다음 페이지를 언제 부를지는 화면이 정하고,
 *   여기서는 자리(`footer`)만 준다. 앱 `shared/ui/MasonryList` 의 웹 포팅.
 * @example
 * <MasonryList inset='tab' data={items} keyExtractor={key}
 *   renderItem={item => <ContentCard ratio='landscape' fixedTextHeight … />} />
 */
import { memo } from "react";

import { masonryListStyles } from "./MasonryList.styles";
import type { MasonryListProps } from "./MasonryList.types";

function MasonryListInner<T>({
  inset = "screen",
  data,
  renderItem,
  keyExtractor,
  header,
  footer,
  empty,
  testID,
}: MasonryListProps<T>) {
  return (
    <div className={masonryListStyles.root} data-testid={testID}>
      {header}
      {data.length === 0 ? (
        empty
      ) : (
        <div className={masonryListStyles.grid({ inset })}>
          {data.map((item, index) => (
            <div
              key={keyExtractor(item, index)}
              className={masonryListStyles.cell}
            >
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      )}
      {footer ? <div className={masonryListStyles.footer}>{footer}</div> : null}
    </div>
  );
}

export const MasonryList = memo(MasonryListInner) as typeof MasonryListInner;
